import React, { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, doc, setDoc, deleteDoc, query, where } from 'firebase/firestore';
import './App.css';

const firebaseConfig = {
  apiKey: "AIzaSyB2YXVFH3c46b2s6amN_KN0uUhmgdGO028",
  authDomain: "tvisit.firebaseapp.com",
  projectId: "tvisit",
  storageBucket: "tvisit.firebasestorage.app",
  messagingSenderId: "285365013974",
  appId: "1:285365013974:web:54b625a1c4ca431a3ce877"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

function App() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [monthData, setMonthData] = useState({});
  const [monthlyStats, setMonthlyStats] = useState({ totalLeft: 0 });
  const [allTimeStats, setAllTimeStats] = useState({ totalLeft: 0 }); // ✨ NEW: All months total

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  // Current month listener
  useEffect(() => {
    const startDate = `${year}-${String(month + 1).padStart(2, '0')}-01`;
    const endDate = `${year}-${String(month + 1).padStart(2, '0')}-31`;
    
    const q = query(collection(db, 'budget'), where('date', '>=', startDate), where('date', '<=', endDate));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = {};
      snapshot.forEach((doc) => data[doc.id] = doc.data());
      setMonthData(data);
      
      const totalExpenses = Object.values(data).reduce((sum, day) => sum + (day.expenses || 0), 0);
      const totalBudget = Object.values(data).reduce((sum, day) => sum + (day.budget || 0), 0);
      setMonthlyStats({ totalLeft: totalBudget - totalExpenses });
    });
    return () => unsubscribe();
  }, [year, month]);

  // ✨ ALL MONTHS listener (runs once)
  useEffect(() => {
    const q = collection(db, 'budget');
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const allData = {};
      snapshot.forEach((doc) => allData[doc.id] = doc.data());
      
      const allExpenses = Object.values(allData).reduce((sum, day) => sum + (day.expenses || 0), 0);
      const allBudget = Object.values(allData).reduce((sum, day) => sum + (day.budget || 0), 0);
      setAllTimeStats({ totalLeft: allBudget - allExpenses });
    });
    return () => unsubscribe();
  }, []);

  const changeMonth = (direction) => {
    setCurrentDate(new Date(new Date().setFullYear(year, month + direction, 1)));
  };

  const updateDayData = async (dateKey, updates) => {
    const existingData = monthData[dateKey] || {};
    await setDoc(doc(db, 'budget', dateKey), { ...existingData, ...updates, date: dateKey });
  };

  const clearDay = async (dateKey) => {
    await deleteDoc(doc(db, 'budget', dateKey));
  };

  const isToday = (dayYear, dayMonth, day) => {
    const today = new Date();
    return dayYear === today.getFullYear() && dayMonth === today.getMonth() && day === today.getDate();
  };

  const renderDays = () => {
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    return (
      <div className="calendar-inner">
        <div className="calendar-headers">
          {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(day => (
            <div key={`header-${day}`} className="weekday">{day}</div>
          ))}
        </div>
        
        <div className="calendar-days">
          {Array(firstDay).fill().map((_, i) => (
            <div key={`empty-${i}`} className="day empty"></div>
          ))}
          
          {Array.from({length: daysInMonth}, (_, day) => {
            const dateKey = `${year}-${String(month + 1).padStart(2, '0')}-${String(day + 1).padStart(2, '0')}`;
            const dayData = monthData[dateKey] || { budget: 0, expenses: 0 };
            
            return (
              <div key={dateKey} className={`day ${isToday(year, month, day + 1) ? 'today' : ''}`}>
                <button 
                  className="clear-btn" 
                  onClick={(e) => { 
                    e.stopPropagation(); 
                    clearDay(dateKey); 
                  }}
                >
                  ×
                </button>
                <div className="day-header">{day + 1}</div>
                <div className="day-budget">
                  <input 
                    type="number" 
                    className="budget-input" 
                    placeholder="Budget" 
                    value={dayData.budget || ''} 
                    onChange={(e) => updateDayData(dateKey, { budget: parseFloat(e.target.value) || 0 })}
                  />
                </div>
                <div className="day-expenses">
                  <input 
                    type="number" 
                    className="expenses-input" 
                    placeholder="Expenses" 
                    value={dayData.expenses || ''} 
                    onChange={(e) => updateDayData(dateKey, { expenses: parseFloat(e.target.value) || 0 })}
                  />
                </div>
                <div className="day-balance">
                  {((dayData.budget || 0) - (dayData.expenses || 0)).toFixed(2)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="app">
      <header>
        <h1> Tasha Why </h1>
        <div className="month-nav">
          <button onClick={() => changeMonth(-1)}>←</button>
          <h2>{currentDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}</h2>
          <button onClick={() => changeMonth(1)}>→</button>
        </div>
      </header>
      
      <div className="stats">
        <div className="stat">
          <span>Budget Left</span>
          <div>${monthlyStats.totalLeft.toFixed(2)}</div>
        </div>
      </div>
      
      <div className="calendar-container">
        <div className="calendar">
          {renderDays()}
        </div>
      </div>

      {/* ✨ ALL MONTHS TOTAL / 4500 ✨ */}
      <div className="month-total-stats">
        <div className="stat month-total-stat">
          <span>Goal Daw</span>
          <div>
            ${allTimeStats.totalLeft.toFixed(2)} / $4,500
            <span className="progress">{((allTimeStats.totalLeft / 4500) * 100).toFixed(0)}%</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;